import { SimpleChanges } from '@angular/core';

export interface OnlineDependentComponent {
  isAppOnline: boolean;
  ngOnChanges(changes: SimpleChanges): void;
}

export function isOnlineDependentComponent(
  object: unknown
): object is OnlineDependentComponent {
  // Call hasOwnProperty function via call function because we don’t know whether the object argument is object type or not.
  return Object.prototype.hasOwnProperty.call(object, 'isAppOnline');
}
